// extracted by mini-css-extract-plugin
module.exports = {"container":"UserPage_container__1wQnR","marginTop2":"UserPage_marginTop2__prhfH"};